<script>
import VideoCard from './VideoCard';
import Stopwatch from '../../services/stopwatch';
import ImageLoader from './ui/ImageLoader';

export default {
  name: 'GameCard',
  components: {
    VideoCard,
    ImageLoader,
  },
  props: {
    game: {
      required: true,
    },
  },
  data: () => ({
    showVideo: false,
  }),
  methods: {
    onMouseEnter () {
      this.__stopWatch = new Stopwatch();
      this.__videoTimeout = setTimeout(() => {
        this.showVideo = true;
      }, 400);
    },
    onMouseLeave () {
      this.$gtm.trackEvent({
        category: 'GameCard Video',
        action: 'watch',
        label: this.game.title,
        game: this.game,
        value: this.__stopWatch.stop(),
      });
      this.stopVideo();
    },
    clearVideoTimeout () {
      if (this.__videoTimeout) {
        clearTimeout(this.__videoTimeout);
        this.__videoTimeout = null;
      }
    },
    stopVideo () {
      this.clearVideoTimeout();
      this.showVideo = false;
    },
  },
  computed: {
    tagToDisplay () {
      if (!this.game.tags) return;
      for (const { text, internal } of this.game.tags) {
        if (!internal) return text;
      }
      return undefined;
    },
  },
  beforeDestroy () {
    this.stopVideo();
  },
  deactivated () {
    this.stopVideo();
  },
};
</script>

<template lang="pug">
div.game-card.tc.bg-light-overlay.relative(v-sound="'progress'", @mouseenter="onMouseEnter", @mouseleave="onMouseLeave")
  transition(enter-active-class="animated fadeIn", leave-active-class="animated fadeOut", v-if="game.videoUrl")
    video-card.videocard.absolute.z-2.h-100.w-100.top-0.left-0(v-if="showVideo", ref="video", :source="game.videoSource")
  ImageLoader.coverimg.absolute.absolute--fill.fit-cover.h-100.w-100(:src="game.imageUrl", crossorigin="anonymous")
    p.placeholder.white.f5.tl.pa2.o-80(slot="error") {{ game.title }}
  span.featuredtag.absolute.left-0.top-0.pa1.f8.ttu.bg-green.black.fw6(v-if="game.featured")
    | Featured
  div.infos.tl.absolute.z-5.left-0.right-0.bottom-0.pr1.pl2.white.f7.flex.items-center
    icon.difficultyicon.mr2.flex-shrink-0(:name="game.difficultyName")
    icon.singleplayericon.mr2.fill-white.flex-shrink-0(name="singleplayer", v-if="game.singleplayer")
    icon.multiplayericon.mr2.fill-white.flex-shrink-0(name="multiplayer", v-if="game.multiplayer", viewBox="0 0 15 11")
    span.cat.fw6.ttc.truncate.pv1 {{ tagToDisplay || '&nbsp;' }}
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped>
@import "styles/variables.css";

.game-card {
  /* steamVR aspect ratio */
  overflow: hidden;
  padding-bottom: 46.73%;
  transition: background-color 0.25s ease-in-out;

  &:hover {
    & .videocard {
      opacity: 1;
    }
    & .placeholder {
      opacity: 1;
    }
    box-shadow: 0 0 6px rgba(255, 255, 255, 1),
      0 0 13px rgba(255, 255, 255, 0.8);
    background-color: #1b1b1b;
  }
  & .videocard {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    transform: scale(1.24);
  }
  &:after {
    z-index: 3;
    content: "";
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 1) 15%,
      rgba(0, 0, 0, 0) 90%
    );
    height: 40%;
    position: absolute;
    bottom: -1px; /*HACK rasterizing bug */
    left: 0;
    right: 0;
    width: 100%;
  }
  & .icon {
    height: 10px;
  }
}
</style>
